var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-input-buttons btn-connect-wallet"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-connect-wallet",modifiers:{"modal-connect-wallet":true}}],staticClass:"btn card-input-button btn-custom btn-none-active"},[_c('b',{staticStyle:{"color":"white"}},[_vm._v("Connect to wallet")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }